import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-toaster', {
    position: 'absolute',
    width: '100%',
    height: 0,
    top: '50px',
});

cssRule('.tb-toast', {
    position: 'relative',
    padding: '6px',
    lineHeight: '16px',
    minHeight: '16px',
    margin: '0 auto 6px auto',
    borderRadius: '1px',
    /* error: '-o-border-radius': '1px', */
    /* error: '-moz-border-radius': '1px', */
    '-webkit-border-radius': '1px',
    /* error: '-khtml-border-radius': '1px', */
    width: '400px',
});

cssRule('.tb-toast >.tb-clear-button', {
    width: '28px',
    height: '28px',
    lineHeight: '28px',
    marginTop: 0,
});

cssRule('.tb-toast-text', {
    width: '377px',
    wordWrap: 'break-word',
    display: 'inline-block',
});


cssRule('.tb-toast-external', {
    width: '768px',
    padding: 0,
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    lineHeight: 'normal',
});

